/**
 * HistoryPanel — placeholder for the History tab.
 *
 * The Phase 10 plan reserves this slot for a future history view (longer-
 * range trend lines, score-over-time, baseline diff timeline). Phase 12 or
 * a follow-up phase will wire it up; for now we render a designed
 * "coming soon" panel so the tab is reachable and the URL contract works.
 */

import { ClockIcon } from '@heroicons/react/24/outline'

export default function HistoryPanel() {
  return (
    <div
      id="panel-history"
      role="tabpanel"
      aria-labelledby="tab-history"
      className="
        rounded-3xl border border-dark-700 bg-dark-800 px-12 py-20
        shadow-[0_1px_2px_rgba(33,41,56,0.04),0_8px_24px_rgba(33,41,56,0.04)]
      "
    >
      <div className="mx-auto flex max-w-xl flex-col items-start text-left">
        <div className="grid h-14 w-14 place-items-center rounded-2xl bg-secondaryBlue-300/30">
          <ClockIcon className="h-7 w-7 text-secondaryBlue-700 dark:text-secondaryBlue-300" />
        </div>
        <div className="mt-5 text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500">
          Coming soon
        </div>
        <h2 className="mt-2 font-display text-[28px] font-extrabold leading-[1.05] tracking-[-0.02em] text-slate-100 dark:text-slate-100">
          A long-form history of your posture.
        </h2>
        <p className="mt-3 text-[14px] leading-[1.55] text-slate-400">
          Score-over-time charts, baseline diff timeline, and per-pillar regression
          alerts. Until this ships, the Posture tab shows the most recent state and
          the 30-day trend; Operations shows the live tail.
        </p>
      </div>
    </div>
  )
}
